import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Chart from 'react-apexcharts';
import { cores, coresGrafico } from '../../../../styles/styleUtils';

const ChartContainer = styled.div`
  background-color: ${cores.branco};
  border-radius: 8px;
  padding: 20px;
`;

const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const SectionTitle = styled.h3`
  font-size: 1.1rem;
  color: ${cores.chumbo};
`;

const FilterButton = styled.button`
  background-color: ${cores.laranja};
  color: ${cores.textoClaro};
  border: none;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: bold;
  cursor: pointer;
  &:hover {
    background-color: ${cores.laranjaEscuro};
  }
`;

const LegendContainer = styled.div`
  display: flex;
  gap: 12px;
  margin: 15px 0;
  flex-wrap: wrap;
`;

const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.85rem;
  color: ${cores.chumbo};
`;

const ColorDot = styled.span`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${(props) => props.color};
`;

const ComparisonChartSection = ({ data }) => {
  const [categorias, setCategorias] = useState([]);
  const [series, setSeries] = useState([]);

  const colors = coresGrafico.slice(0, 2); // mesma ordem da série

  useEffect(() => {
    setCategorias(data.categorias);
    setSeries(data.series);
  }, [data]);

  const options = {
    chart: {
      type: 'bar',
      stacked: false,
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: '50%',
      },
    },
    dataLabels: {
      enabled: true,
      style: { fontSize: '11px' },
      formatter: (val) => val.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
    },
    xaxis: {
      categories: categorias,
      labels: { style: { fontSize: '12px' } },
    },
    yaxis: {
      labels: { style: { fontSize: '12px' } },
    },
    legend: {
      show: false, // Desliga a legenda interna do ApexCharts
    },
    colors,
    tooltip: {
      y: { formatter: (val) => val.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) },
    },
  };

  return (
    <ChartContainer>
      <SectionHeader>
        <SectionTitle>Despesas do Mês</SectionTitle>
      </SectionHeader>

      {/* Legenda personalizada */}
      <LegendContainer>
        {series.map((s, index) => (
          <LegendItem key={s.name}>
            <ColorDot color={colors[index % colors.length]} />
            {s.name}
          </LegendItem>
        ))}
      </LegendContainer>

      <Chart options={options} series={series} type="bar" height={350} />
    </ChartContainer>
  );
};

export default ComparisonChartSection;